/* eslint-disable react/jsx-no-duplicate-props */
import React  from "react";
import { Link } from "react-router-dom";
import logo from "../assets/static/logo.svg";
// import Cookies from "universal-cookie";
import { useHistory } from "react-router-dom";

import Cookies from "universal-cookie";
import axios from "axios";
import { connect } from "react-redux";
import i18n from "i18next";
import { withTranslation } from "react-i18next";
import {Popover, Overlay} from "react-bootstrap"

import { BaseUrl } from "./api";
import ProgressBar from "./ProgressBar";

const current = new Date();
var nextYear = new Date();
nextYear.setFullYear(current.getFullYear() + 1);

function withParams(Component) {
  return (props) => <Component {...props} history={useHistory()} />;
}
const cookies = new Cookies();
// const lngs = [
//   // { code: "uz", nativeName: "O`z" },
//   { code: "ru", nativeName: "Ру" },
// ];
class AppHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cart: [],
      search: "",
      show: false,
      regions: [],
      region: "",
      lngShow: false,
      query: "",
      elements: false,
      color: "#29488D", 
      target: null,
      target_show: false,
      progress: 0,
    };
    this._isMounted = false;
    if (cookies.get("Language")) {
      this.lang = cookies.get("Language");
    } else {
        this.lang = "ru";
      }
      if (this.lang === "uz") {
        this.name = "nameUz";
        this.language = "O`z";
      } else {
        this.lang = "ru";
        this.name = "nameRu";


      }
    cookies.set("Language", this.lang);
    i18n.changeLanguage(this.lang);
    this.showModal = this.showModal.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.buttonRef = React.createRef();
    this.length = 0;
   
  }
  async componentDidMount() {
    this._isMounted = true;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    let data = [];

    let region = "Hudud";
    await axios.get(BaseUrl + "regions/").then((res) => {
      this.regions = res.data;
      this._isMounted &&
        this.setState({
          regions: this.regions,
        });
    });
    if (cookies.get("Region")) {
      let id = parseInt(cookies.get("Region"));
      let reg = this.regions.find((item) => item.id === id);
      region = reg[this.name];
    } else {
      region = this.regions[0][this.name];

      this.interval = setInterval(() => {
        this.setState((prevState) => {
          if (prevState.progress >= 100) {
            this.setYesButton();
            clearInterval(this.interval);
            return { progress: 100 };
          }
          cookies.set("Region", this.regions[0].id);
          return { progress: prevState.progress + 1 };
        });
      }, 100);
     

      this._isMounted &&
        this.setState({
          target: this.buttonRef.current, 
          target_show: true
        });

    }
    if (cookies.get("Cart")) {
      data = cookies.get("Cart");
    }
    this._isMounted &&
      this.setState({
        cart: data.length,
        region,
      });
  }

  setYesButton = () => {
    this.setState({ target_show: false });
    cookies.set("Region", this.regions[0].id);
  }

 
  componentDidUpdate(prevProps) {
    if (this.props.parentData !== prevProps.parentData) {
      this._isMounted = true;
      this._isMounted &&
        this.setState(
          {
            cart: this.props.parentData,
          },
          () => console.log(this.state.cart)
        );
    }
  }
  showModal = () => {
    this._isMounted &&
      this.setState(
        {
          show: true,
        },
        () => console.log(this.state.show)
      );
  };
  hideModal = () => {
    this._isMounted &&
      this.setState({
        show: false,
      });
  };
  handleClick = (e) => {
    e.preventDefault();
    console.log(e.target.name);
    cookies.set("Region", e.target.name, { expires: nextYear });
    let id = parseInt(cookies.get("Region"));
    const reg = this.state.regions.find((item) => item.id === id);
    console.log(this.state.regions);
    this._isMounted &&
      this.setState(
        {
          region: reg.name,
        },
        () => console.log(this.state.region)
      );
    this.hideModal();
    window.location.reload(false);
  };
  // handleLanguage = (lng) => {
  //   this._isMounted &&
  //     this.setState({
  //       lngShow: false,
  //     });
  //   i18n.changeLanguage(lng);
  //   cookies.set("Language", lng);
  //   window.location.reload(false);
  // };
  getQuery = (e) => {
    if (e.key === "Enter") {
      this.props.history.push(`/searcht?offset=0&query=` + e.target.value);
    }
  };
  closeContent = () => {
    this._isMounted &&
      this.setState({
        elements: false,
      });
  };
  componentWillUnmount() {
    this._isMounted = false;
    clearInterval(this.interval);
  }

   
  render() {
    const { t } = this.props;
    const history = this.props.history;
    return (
      <div className="header">
        <header>
          <div>
            <section >
              <div
                id="myModal"
                className={this.state.show ? `mod modalOpen` : "mod"}
              >
                <div className="modalContent flex center">
                <button className="close-button item-button gray " onClick={() => this.hideModal()}>
                <i className="fa-solid fa-xmark"></i>
                </button>
                <span><h1 className="text-title">{t("choseLocation.text")}</h1></span>
                  

                  <p className="pt-1 text">{t("availableShops.text")}:</p>
                  <div className="regions-container mt-2">
                    {this.state.regions
                      .filter((el) => el.isActive === true)
                      .map((item) => (
                        <button
                          key={item.id}
                          onClick={(e) => this.handleClick(e)}
                          name={item.id}
                          className="region"
                        >
                          {item[this.name]}
                        </button>
                      ))}
                  </div>

                  <hr className="mt-2" />
                  <p className="pt-1 text">{t("sagSoon.text")}:</p>
                  <div className="regions-container mt-2">
                    {this.state.regions
                      .filter((el) => el.isActive === false)
                      .map((item) => (
                        <button
                          key={item.id}
                          name={item.id}
                          className="region disabled"
                        >
                          {item[this.name]}
                        </button>
                      ))}
                  </div>
                </div>
              </div>

              {/* <form className="col-5">  */}
              <div className="left-header">
                <div className="pointer">
                  <Link  to="/">
                  {/* <img src={logo} alt="logo" />{" "} */}
                  <svg
                    ref={this.buttonRef}
                    xmlns="http://www.w3.org/2000/svg"
                    xmlSpace="preserve"
                    width="114px"
                    height="45px"
                    version="1.1"
                    style={{
                      shapeRendering: 'geometricPrecision',
                      textRendering: 'geometricPrecision',
                      imageRendering: 'optimizeQuality',
                      fillRule: 'evenodd',
                      clipRule: 'evenodd',
                    }}
                    viewBox="0 0 97121.59 30284.17"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    xmlnsXodm="http://www.corel.com/coreldraw/odm/2003"
                  >
        <defs>
          <style type="text/css">
            {`
              <![CDATA[
                .fil0 {fill:#29488D}
                .fil1 {fill:#29488D;fill-rule:nonzero}
              ]]>
            `}
          </style>
        </defs>
        <g id="Слой_x0020_1">
        <metadata id="CorelCorpID_0Corel-Layer"/>
  <g id="_2619095203648">
   <path  fill={this.state.color} d="M36822.99 17355.39l5698.78 -395.65c122.2,1021.34 375.5,1802.29 755.34,2333.29 619.44,866.06 1501.4,1301.62 2650.3,1301.62 854.68,0 1515.4,-220.46 1976.59,-666.01 465.68,-445.47 696.45,-961.04 696.45,-1546.83 0,-556.01 -217.21,-1056.76 -655.95,-1497.2 -438.32,-440.51 -1460.97,-851.11 -3066.16,-1246.69 -2632.25,-650.64 -4504.75,-1522.02 -5626.66,-2608.61 -1130.86,-1081.09 -1695.79,-2463.28 -1695.79,-4145.52 0,-1101.49 289.32,-2142.67 867.96,-3124.17 578.93,-986.05 1447.33,-1757.43 2610.08,-2317.93 1162.12,-560.83 2754.39,-841.12 4776.03,-841.12 2483.12,0 4373.66,510.61 5675.97,1536.97 1302.59,1021.34 2076.06,2648.38 2324.81,4881.61l-5644.7 370.28c-148.99,-975.99 -465.6,-1687.27 -944.85,-2127.65 -483.93,-445.54 -1148.76,-666 -1994.71,-666 -696.37,0 -1225.64,165.19 -1578.34,490.68 -353.06,325.56 -529.26,726.17 -529.26,1196.66 0,340.38 144.66,645.89 429.58,921.28 275.61,285.18 945.2,545.81 2003.45,790.81 2623.37,626.03 4500.34,1261.78 5631.06,1902.76 1135.19,640.99 1962.95,1431.95 2478.35,2383.06 515.69,946.22 773.76,2007.8 773.76,3184.41 0,1376.73 -343.82,2648.37 -1031.39,3814.99 -692.04,1161.72 -1650.95,2047.64 -2889.88,2648.86 -1235.03,600.68 -2790.92,900.95 -4672.23,900.95 -3301.7,0 -5590.56,-705.84 -6861.25,-2112.83 -1271.04,-1406.57 -1989.8,-3194.33 -2157.34,-5362.02zm32582.32 3569.71l-6801.85 0 -977.31 3544.71 -6128.36 0 7313.14 -21508.86 6571.93 0 7281.66 21508.86 -6286.73 0 -972.49 -3544.71zm-1270.97 -4656.18l-2120.89 -7730.46 -2130.63 7730.46 4251.52 0zm19706.12 420.53l0 -4475.97 9281.13 0 0 9147.1c-1777.57,1341.87 -3347.1,2258.18 -4708.31,2743.89 -1365.97,485.31 -2985.23,725.76 -4857.81,725.76 -2306.41,0 -4188.07,-435.55 -5639.8,-1306.59 -1451.73,-866.06 -2577.69,-2163.07 -3378.37,-3885.21 -800.54,-1717.59 -1198.92,-3695 -1198.92,-5922.86 0,-2348.17 438.89,-4385.89 1311.97,-6123.4 872.8,-1732.48 2152.93,-3048.99 3839.98,-3950.41 1315.81,-695.78 3088.55,-1041.19 5314.03,-1041.19 2144.27,0 3749.41,215.09 4812.48,645.61 1067.48,430.86 1949.02,1096.53 2650.66,2002.77 700.85,906.38 1230.18,2053.08 1582.39,3439.74l-5779.71 1151.65c-240.01,-816.24 -642.37,-1441.93 -1212.21,-1872.79 -570.19,-435.55 -1293.43,-650.64 -2180.22,-650.64 -1311.4,0 -2360.91,505.64 -3143.05,1517.06 -782.63,1011.35 -1171.64,2613.57 -1171.64,4801.52 0,2322.89 393.92,3985.21 1184.86,4981.6 786.97,996.06 1890.9,1496.72 3301.77,1496.72 669.59,0 1307.14,-105.03 1917.68,-320.11 605.86,-215.43 1302.8,-580.83 2089.64,-1091.49l0 -2012.76 -4016.56 0z"/>
   <polygon fill={this.state.color} points="20760.38,7212.17 14342.36,13728.84 20760.38,20245.16 27218.14,13728.84 "/>
   <polygon fill={this.state.color} points="35063.1,7212.17 28645.42,13728.84 35063.1,20245.16 "/>
   <polygon fill={this.state.color} points="27891.28,14397.9 21473.18,20914.57 27891.28,27430.89 34349.81,20914.57 "/>
   <polygon fill={this.state.color} points="27891.28,0 21473.18,6516.33 27891.28,13032.65 34349.81,6516.33 "/>
   <polygon fill={this.state.color} points="13589.77,14397.9 7171.31,20914.57 13589.77,27430.89 20047.59,20914.57 "/>
   <polygon fill={this.state.color} points="13589.77,0 7171.31,6516.33 13589.77,13032.65 20047.59,6516.33 "/>
   <polygon fill={this.state.color} points="6418.81,7212.17 -0,13728.84 6418.81,20245.16 12876.13,13728.84 "/>
   <path fill={this.state.color} d="M37982.72 26921.38l668.87 0 0 1406.93c148.39,-15.38 249.1,-53.05 301.38,-115.32 52.28,-61.5 133.77,-232.95 242.94,-514.34 137.62,-357.5 276.77,-580.46 415.93,-667.33 138.39,-86.87 360.57,-130.7 668.1,-130.7 15.37,0 47.67,-0.77 96.87,-2.31l0 493.58 -94.57 -2.31c-136.85,0 -236.8,16.91 -299.83,50.74 -63.05,33.83 -113.79,85.34 -153,154.53 -39.21,69.19 -96.87,211.42 -172.98,426.69 -40.74,114.55 -84.57,209.88 -132.24,286.76 -46.89,76.88 -130.7,149.15 -250.63,216.8 148.39,41.52 270.63,126.86 367.49,254.48 96.88,127.63 202.98,307.52 318.29,540.47l449.75 904.13 -784.19 0 -395.94 -850.31c-6.15,-12.3 -19.22,-35.36 -38.44,-69.96 -7.69,-11.54 -35.36,-63.81 -83.03,-155.3 -84.57,-162.99 -153.77,-264.48 -207.58,-305.22 -54.59,-40.74 -136.85,-61.5 -248.33,-63.05l0 1443.84 -668.87 0 0 -3302.83zm13273.19 1671.4c0,-336.74 50.74,-619.67 151.46,-848.77 74.57,-168.37 177.59,-319.83 307.52,-453.6 129.93,-133.77 272.16,-232.95 426.69,-298.3 206.04,-86.87 443.61,-130.7 712.69,-130.7 487.43,0 876.45,151.46 1169.37,453.6 292.15,302.91 438.23,723.45 438.23,1262.39 0,534.33 -145.31,952.56 -435.15,1253.94 -289.84,302.14 -678.09,452.83 -1163.21,452.83 -491.27,0 -882.6,-149.92 -1172.45,-450.53 -289.84,-299.83 -435.15,-713.46 -435.15,-1240.86zm687.32 -22.29c0,374.42 86.87,658.1 259.86,851.84 172.99,192.98 392.87,289.84 658.88,289.84 266.78,0 485.13,-96.1 656.57,-287.53 170.68,-192.21 256.02,-479.74 256.02,-863.38 0,-379.03 -83.04,-661.96 -249.87,-848.01 -166.07,-186.82 -386.72,-279.85 -662.72,-279.85 -275.24,0 -497.42,94.57 -665.79,282.93 -168.37,189.13 -252.94,473.59 -252.94,854.15zm13644.53 -1649.11l1320.82 0c262.17,0 456.68,10.76 585.07,32.29 129.16,22.29 243.71,67.66 345.2,136.08 101.48,69.19 186.05,160.68 253.7,275.23 67.66,114.56 101.49,243.72 101.49,385.95 0,153.76 -41.52,295.99 -124.55,424.38 -83.03,129.16 -196.04,225.26 -338.28,289.84 200.66,59.2 354.42,159.15 462.82,300.61 107.63,141.46 161.45,307.52 161.45,498.96 0,150.69 -34.6,296.76 -104.56,438.99 -69.96,142.23 -165.29,256.02 -286.76,341.35 -120.7,84.57 -269.86,136.85 -447.45,156.84 -110.71,11.54 -379.03,19.22 -804.18,22.29l-1124.78 0 0 -3302.83zm668.87 548.93l0 761.12 436.69 0c259.09,0 420.55,-3.85 483.58,-11.53 113.79,-13.08 203.74,-52.29 269.09,-117.64 65.35,-65.35 97.63,-150.69 97.63,-256.78 0,-102.26 -28.44,-184.52 -84.56,-248.33 -56.12,-63.81 -139.93,-102.25 -250.63,-115.32 -66.12,-7.68 -256.02,-11.53 -568.92,-11.53l-382.87 0zm0 1310.06l0 885.68 618.13 0c239.87,0 392.86,-6.92 457.45,-19.99 99.18,-18.45 179.91,-62.27 242.18,-132.24 62.28,-70.73 93.8,-163.76 93.8,-281.38 0,-99.94 -23.83,-183.74 -72.27,-252.93 -47.67,-69.19 -117.63,-119.94 -208.35,-151.46 -90.72,-31.52 -288.31,-47.67 -591.99,-47.67l-538.94 0zm13267.81 1443.84l0 -3302.83 1069.42 0c405.17,0 668.87,16.14 791.88,49.2 189.13,49.98 347.51,157.61 475.13,323.67 127.63,166.07 191.44,380.56 191.44,643.5 0,202.97 -36.91,372.88 -109.95,511.27 -73.81,138.39 -166.83,246.79 -279.84,325.97 -113.02,78.42 -228.34,130.7 -345.2,156.07 -159.15,31.53 -389.03,47.67 -690.4,47.67l-433.62 0 0 1245.48 -668.87 0zm668.87 -2744.67l0 941.03 363.65 0c262.17,0 436.69,-17.68 525.1,-52.28 88.41,-34.6 157.61,-88.42 207.58,-162.99 49.98,-73.81 75.35,-159.15 75.35,-257.56 0,-120.7 -35.37,-219.87 -105.33,-298.3 -70.73,-78.42 -159.15,-127.62 -267.55,-147.61 -79.18,-14.6 -238.33,-22.29 -478.2,-22.29l-320.59 0zm13031.79 -558.16l668.87 0 0 1319.28 891.06 0c233.72,0 435.15,32.29 603.52,96.11 168.37,63.8 309.06,177.59 422.07,342.12 112.25,164.53 168.37,353.66 168.37,567.38 0,223.73 -58.43,415.93 -175.28,578.15 -117.63,161.46 -247.56,268.32 -391.33,320.6 -143,53.05 -352.89,79.18 -628.89,79.18l-1558.39 0 0 -3302.83zm668.87 2744.67l650.42 0c206.81,0 351.34,-10 433.62,-29.98 81.49,-19.99 154.52,-66.12 218.34,-137.62 63.81,-71.5 95.33,-158.38 95.33,-261.4 0,-146.08 -52.28,-256.01 -156.07,-329.05 -104.56,-73.04 -292.92,-109.17 -564.31,-109.17l-677.33 0 0 867.22zm2467.9 -2744.67l668.87 0 0 3302.83 -668.87 0 0 -3302.83z"/>
        </g>
      </g>
      </svg>
                  </Link>
                  <Overlay target={this.state.target} show={this.state.target_show} placement="bottom">
                    <Popover id="popover-basic" style={{ position: "relative", top: "0px" }}>
                      <Popover.Title as="h3">{t("yourcity.text")} {this.state.region}?</Popover.Title>
                      <ProgressBar  />
                      <Popover.Content className="modal-buttons">
                      <button className=" btn-primary" onClick={this.setYesButton} type="button">Да</button>
                      <button className=" btn-secondary" onClick={() => this.setState({target_show: false, show: true })} type="button">Нет</button>

{/*                        
                          <div className="col-6 d-flex justify-content-start">
                            <button className=" btn-primary" onClick={() => this.setState({ target_show: false })} type="button">Yes</button>
                          </div>
                          <div className="col-6 d-flex justify-content-end">
                            <button className=" btn-secondary" onClick={() => this.setState({target_show: false, show: true })} type="button">No</button>
                          </div> */}
                      </Popover.Content>
                    </Popover>
                  </Overlay>
                </div>
              
                  
                 
                <div className="search-input">
                  <div className="search-icon"></div>
                  <div>
                    <input
                      onKeyDown={(e) => this.getQuery(e)}
                      onChange={(e) =>
                        this._isMounted &&
                        this.setState({ query: e.target.value })
                      }
                      className={this.state.query.length > 0 ? "focus" : ""}
                      type="search"
                      name="query"
                      value={this.state.query}
                      placeholder={t("searchPlaceholder.text")}
                    />
                  </div>
                </div>
              </div>
              <div className="right-header">
                {/* <Link to="/services" className="text services">
                  {t("services.text")}
                </Link> */}
                <Link to="/contacts" className="text services">{t("Addresses.text")}</Link>

                <span className="vertical-line"></span>
                <div className="pointer location">
                  <i className="fa-regular fa-map fa-sm icon"></i>
                  <span className="text" onClick={() => this.showModal()}>
                    {" " + this.state.region}
                  </span>
                </div>
                {/* <div className="dropdown">
                  <button
                    className="dropbtn"
                    onClick={() =>
                      this._isMounted && this.setState({ lngShow: true })
                    }
                  >
                    {this.language}
                  </button>
                  <div
                    className={
                      this.state.lngShow
                        ? "dropdown-content show"
                        : "dropdown-content"
                    }
                  >
                    {lngs.map((lng) => {
                      return (
                        <p
                          className=" p-2  language"
                          key={lng.code}
                          type="submit"
                          onClick={() => this.handleLanguage(lng.code)}
                        >
                          {lng.nativeName}
                        </p>
                      );
                    })}
                  </div>
                </div> */}
                <div
                  className="cart pointer"
                  onClick={() => history.push("/cart")}
                >
                  <i className="fa-solid fa-cart-shopping icon"></i>
                  {this.props.numberCart !== 0 && (
                    <span className="basket-badge text-xs">
                      {this.props.numberCart}
                    </span>
                  )}
                </div>
                <div
                  className="bar-menu pointer"
                  onClick={() =>
                    this._isMounted &&
                    this.setState({
                      elements: true,
                    })
                  }
                >
                  <i className="fa-solid fa-bars fa-2xl"></i>
                </div>
              </div>
            </section>
          </div>
          {this.state.elements === true && (
            <div className="elements" >
              <div className="open-content text-lg">
                <div className="pointer " onClick={() => this.closeContent()}>
                  {/* <Link to="/services">{t("services.text")}</Link> */}
                  <Link to="/contacts" >{t("Addresses.text")}</Link>
                </div>
                <div
                  className="pointer"
                  style={{ paddingBottom: "10px" }}
                  onClick={() => this.closeContent()}
                >
                  <i className="fa-regular fa-map fa-sm icon"></i>
                  <span onClick={() => this.showModal()}>
                    {" " + this.state.region}
                  </span>
                </div>
                {/* <div>
                  <button
                    className="dropbtn text-lg"
                    onClick={() => {
                      this._isMounted && this.setState({ lngShow: true });
                    }}
                  >
                    <i className="fa-solid fa-earth-europe px-1 icon"></i>
                    {this.language}
                  </button>
                  <div
                    className={
                      this.state.lngShow
                        ? "dropdown-content show"
                        : "dropdown-content"
                    }
                  >
                    {lngs.map((lng) => {
                      return (
                        <p
                          className=" p-2  language"
                          key={lng.code}
                          type="submit"
                          onClick={() => {
                            this.handleLanguage(lng.code);
                            this.closeContent();
                          }}
                        >
                          {lng.nativeName}
                        </p>
                      );
                    })}
                  </div>
                </div> */}
                <div
                  className="pointer"
                  onClick={() => {
                    history.push("/cart");
                    this.closeContent();
                  }}
                  style={{ display: "flex" }}
                >
                  <span>
                    <i
                      className="fa-solid fa-cart-shopping icon"
                      style={{ marginRight: "0" }}
                    ></i>
                  </span>
                  {this.props.numberCart ? (
                    <span
                      className="basket-badge text-xs"
                      style={{ top: "5px" }}
                    >
                      {this.props.numberCart}
                    </span>
                  ) : (
                    <span style={{ marginRight: "15px" }}></span>
                  )}
                  <span>{t("cart.text")}</span>
                </div>
                <div style={{ paddingBottom: "10px" }}>
                  <img src={logo} alt="logo" />{" "}
                </div>
                <div
                  className="close-icon"
                  style={{ fontSize: "30px" }}
                  onClick={() => this.closeContent()}
                >
                  <i className="fa-solid fa-xmark icon"></i>
                </div>
              </div>
            </div>
          )}
        </header>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    numberCart: state._todoProduct.numberCart,
  };
};
export default withParams(
  connect(mapStateToProps, null)(withTranslation()(AppHeader))
);
